import { mapGetters } from 'vuex';
import { Loading } from 'element-ui';
import mixins from '@/mixins';
import { closest } from '@/utils/util.js';
import { loginout } from '@/api/user.js';

export default {
	name: 'UserCenter',

	props: {},

	data() {
		return {
			showUserPannel: false
		};
	},

	computed: {
    ...mapGetters(['isLogin', 'userName', 'photo', 'balance', 'userId', 'userToken', 'appid']),
  },

	methods: {
		init() {
      this.hideUserPannel();
    },

		signin() {
			const redirectURL = window.location.href.split('?')[0];

			if (/pre.cozytaps.com/.test(window.location.href)) {
				window.location.href = `https://pre-auth.cozytaps.com/web?appid=01e5928099b54933bcf1ebad2bf81c32&redirect_url=${encodeURIComponent(redirectURL)}`;
				return;
			}
			
      window.location.href = `https://auth.cozytaps.com/web?appid=01e5928099b54933bcf1ebad2bf81c32&redirect_url=${encodeURIComponent(redirectURL)}`;
    },

    hideUserPannel() {
      document.removeEventListener('click', this.docHandler);
      document.addEventListener('click', this.docHandler);
    },

    docHandler(e) {
      let pannel = closest(e.target, 'user-pannel');
      let loginfo = closest(e.target, 'login-info');

      if (pannel || loginfo) {
        return;
      }

      this.showUserPannel = false;
    },

    showPannelToggle() {
      this.showUserPannel = !this.showUserPannel;
    },

    async logout() {
    	const loading = Loading.service({
		    fullscreen: true,
		    customClass: 'text-loading',
		    text: 'Loading...'
		  });

    	try {
    		const res = await loginout({
					token: this.userToken,
					appid: this.appid
				});
	      this.$store.dispatch('loginout');
	      this.$message({
	        message: 'Loginout successful',
	        type: 'success',
	        showClose: true,
	        customClass: 'custom-message',
	      });
	      loading.close();
    	}
    	catch(err) {
    		loading.close();

    		if (err.code) {
    			this.$message({
		        message: err.message,
		        type: 'error',
		        showClose: true,
		        customClass: 'custom-message',
		      });
		      return;
    		}

    		this.$message({
	        message: 'Loginout fail',
	        type: 'error',
	        showClose: true,
	        customClass: 'custom-message',
	      });
    	}
    }
	},

	mounted() {
    this.init();
  }
};


